// 検索-都道府県選択時、対応する市区町村一覧を取得・生成

$(function () {
  window.addEventListener("load", makeCityList);
  window.addEventListener("load", makeAdministrativeDistrictList);

  $(".js-prefecture-select").on("change", makeCityList);
  $(".js-prefecture-select").on("change", makeAdministrativeDistrictList);
  $(".js-city-select").on("change", makeAdministrativeDistrictList);
});

function makeCityList() {
  const prefCd = $(".js-prefecture-select").val();
  const $city = $(".js-city-select");

  if (!prefCd) {
    $city.empty();
    $city.append('<option value="">市区町村</option>');
    $city.val("");
    $city.prop("disabled", true);
    $city.parents(".input-select-front").addClass("is-disabled");
    return;
  }

  // 復元候補の保持（現在の選択値）
  const keepCityId = $city.val();

  $.getJSON("/home/make_city_list?prefCd=" + prefCd, (json) => {
    // 市区町村セレクトボックスのクリア
    $city.empty();

    // 市区町村セレクトボックスの生成
    let options = '<option value="">選択してください</option>';
    for (const row of json.data) {
      options += `<option value="${row.id}">${row.name}</option>`;
    }
    $city.append(options);

    // セレクトボックスの有効化
    $city.prop("disabled", false);
    $city.parents(".input-select-front").removeClass("is-disabled");

    // 選択値を復元（リストに存在する場合のみ）
    if (keepCityId && json.data.some((r) => String(r.id) === String(keepCityId))) {
      $city.val(String(keepCityId));
    }
  });
}

function makeAdministrativeDistrictList() {
  const prefCd = $(".js-prefecture-select").val();
  const cityCd = $(".js-city-select").val();
  const $administrativeDistrict = $(".js-administrative_district-select");

  if (!cityCd) {
    $administrativeDistrict.empty();
    $administrativeDistrict.append('<option value="">行政区</option>');
    $administrativeDistrict.val("");
    $administrativeDistrict.prop("disabled", true);
    $administrativeDistrict.parents(".input-select-front").addClass("is-disabled");
    return;
  }

  // 復元候補の保持（現在の選択値）
  const keepAdministrativeDistrictId = $administrativeDistrict.val();

  $.getJSON("/home/make_administrative_district_list?prefCd=" + prefCd + "&cityCd=" + cityCd, (json) => {
    // 行政区セレクトボックスのクリア
    $administrativeDistrict.empty();

    // データが空なら無効化して終了
    if (!json || !Array.isArray(json.data) || json.data.length === 0) {
      $administrativeDistrict.append('<option value="">行政区</option>');
      $administrativeDistrict.val("");
      $administrativeDistrict.prop("disabled", true);
      $administrativeDistrict.parents(".input-select-front").addClass("is-disabled");
      return;
    }

    // 行政区セレクトボックスの生成
    let options = '<option value="">選択してください</option>';
    for (const row of json.data) {
      options += `<option value="${row.id}">${row.name}</option>`;
    }
    $administrativeDistrict.append(options);

    // セレクトボックスの有効化
    $administrativeDistrict.prop("disabled", false);
    $administrativeDistrict.parents(".input-select-front").removeClass("is-disabled");

    // 選択値を復元（リストに存在する場合のみ）
    if (keepAdministrativeDistrictId && json.data.some((r) => String(r.id) === String(keepAdministrativeDistrictId))) {
      $administrativeDistrict.val(String(keepAdministrativeDistrictId));
    }
  });
}
